import React, { useEffect, useState } from "react";
import { CubeIcon } from "@heroicons/react/outline";
import { apiGet, apiPut } from "helpers/Request";
import { useAuth } from "hooks/Auth";
import { transform as versionTransformer } from "schemas/Version";
import Pagination from "components/General/Pagination";
import { getPaginationMeta } from "schemas/Util";
import { fromSqlDateTime } from "helpers/Date";
import HtmlDiff from "htmldiff-js";
import SecondaryButton from "components/Buttons/SecondaryButton";
import { ArrowLeftIcon } from "@heroicons/react/outline";

export default function VersionCompare(props) {
    const [loading, setLoading] = useState(false);
    const [versions, setVersions] = useState([]);
    const [compare, setCompare] = useState([]);
    const [page, setPage] = useState(0);
    const auth = useAuth();

    const { content } = props;
    const [paginationMeta, setPaginationMeta] = useState({});

    const showCompare = (v1, v2) => {
        setLoading(true);
        apiGet(`/v4/content/${content.uuid}/compare`, auth.publication, {
            page: page,
            per_page: 20,
            current: v1,
            past: v2,
            include: "user",
        }).then((resp) => {
            setLoading(false);
            setCompare(versionTransformer(resp));
        });
    };

    const restore = (uuid) => {
        apiPut(`/v4/version/${uuid}`, auth.publication)
            .then((resp) => {
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
                alert(
                    "There was an error restoring, you may not have permission"
                );
            });
    };

    useEffect(() => {
        if (!content || !content.uuid) {
            return;
        }
        setCompare([]);
        setLoading(true);
        apiGet(`/v4/content/${content.uuid}/version`, auth.publication, {
            page: page,
            per_page: 20,
            include: "user",
        }).then((resp) => {
            setVersions(versionTransformer(resp));
            setLoading(false);
            setPaginationMeta(getPaginationMeta(resp));
        });
    }, [content, page, auth.publication]);

    if (loading) {
        return (
            <div className="w-full py-10 text-center">
                <CubeIcon className="mx-auto h-8 w-8 animate-rotate-pulse text-gray-300" />
            </div>
        );
    }

    if (compare && compare.length === 2) {
        return (
            <div className="w-full">
                <div className="mb-5 flex space-x-4">
                    <SecondaryButton
                        onClick={() => setCompare([])}
                        label={
                            <div className="flex">
                                <ArrowLeftIcon className="mr-2 h-5 w-5" />
                                <span>Back</span>
                            </div>
                        }
                    />
                    <SecondaryButton
                        onClick={() => restore(compare[1].uuid)}
                        className="ml-auto"
                        label={
                            <span>Restore Version {compare[1].version}</span>
                        }
                    />
                    <SecondaryButton
                        onClick={() => restore(compare[0].uuid)}
                        label={
                            <span>Restore Version {compare[0].version}</span>
                        }
                    />
                </div>
                <div className="flex">
                    <div className="differ flex-grow pr-1">
                        <div className="font-weight-bold mb-4 border-b border-gray-300 text-lg">
                            Version {compare[1].version} -{" "}
                            {compare[1].user?.name || "Unknown User"}
                        </div>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: HtmlDiff.execute(
                                    compare[0].content,
                                    compare[1].content
                                ),
                            }}
                        ></div>
                    </div>
                    <div className="differ flex-grow pl-1">
                        <div className="font-weight-bold mb-4 border-b border-gray-300 text-lg">
                            Version {compare[0].version} -{" "}
                            {compare[0].user?.name || "Unknown User"}
                        </div>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: HtmlDiff.execute(
                                    compare[1].content,
                                    compare[0].content
                                ),
                            }}
                        ></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div>
            <Pagination
                onClick={(meta) => setPage(meta.page)}
                {...paginationMeta}
            />
            <div className="w-full divide-y divide-gray-200">
                {versions.map((version) => (
                    <div key={version.id} className="py-4">
                        <div className="flex  align-middle">
                            <strong className="font-weight-bold text-gray-900">
                                Version {version.version}
                            </strong>
                            <div className="ml-4">
                                Edited By:{" "}
                                {version.user?.name || "Unknown User"}
                            </div>
                            <div className="ml-4">
                                On:{" "}
                                {fromSqlDateTime(version.modified_at).toFormat(
                                    "ff"
                                )}{" "}
                            </div>
                            <div className="ml-4">
                                {version.version !== content.version - 1 && (
                                    <button
                                        onClick={() =>
                                            showCompare(
                                                version.version,
                                                version.version - 1
                                            )
                                        }
                                        className="mr-2 rounded border border-gray-500 bg-white py-1 px-2 text-xs text-gray-700 hover:cursor-pointer"
                                    >
                                        Compare to previous
                                    </button>
                                )}
                                <button
                                    onClick={() =>
                                        showCompare(
                                            content.version,
                                            version.version
                                        )
                                    }
                                    className="mr-2 rounded border border-gray-500 bg-white py-1 px-2 text-xs text-gray-700 hover:cursor-pointer"
                                >
                                    Compare to current
                                </button>
                                <button
                                    onClick={() => restore(version.uuid)}
                                    className="rounded border border-gray-500 bg-white py-1 px-2 text-xs text-gray-700 hover:cursor-pointer"
                                >
                                    Restore
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/*<ReactGhLikeDiff
                options={{
                    originalFileName: "Original",
                    updatedFileName: "Updated",
                }}
                past={content.content}
                present={versions ? versions[1].content : content.content}
            />*/}
        </div>
    );
}
